import React from 'react';
import { Link } from "react-router-dom";
import { FaLinkedinIn, FaFacebookF, FaInstagram, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        
        {/* Company Description */}
        <div className="footer-col company-desc">
          <Link to="/" aria-label="Inypeople Home">
            <img src="/assets/logo/inypeople-logo.png" alt="Inypeople Logo" className="footer-logo" />
          </Link>

          <p>
            Founded in 2024, Inypeople is a leading provider of innovative solutions, IT services, and staffing solutions. Our expertise in cutting-edge technology and skilled professionals ensures exceptional service and customer satisfaction across various industries.
          </p>

          <div className="footer-social">
            <span>Stay Connected</span>
            <div className="footer-icons">
              <a href="https://www.facebook.com/people/Inypeople/61551082705143/" target="_blank" rel="noopener noreferrer" className="footer-social-link">
                <FaFacebookF size={28} color="#1877F3" />
              </a>

              <a href="https://www.instagram.com/inypeople/" target="_blank" rel="noopener noreferrer" className="footer-social-link">
                <FaInstagram size={28} color="#DD2A7B" />
              </a>

              <a href="https://www.linkedin.com/company/inypeople-technology/" target="_blank" rel="noopener noreferrer" className="footer-social-link">
                <FaLinkedinIn size={28} color="#0A66C2" />
              </a>
            </div>
          </div>
        </div>

        {/* Services */}
        <div className="footer-col services">
          <h3>Services</h3>
          <ul>
            <li><Link to="/services/web-development">Web Development</Link></li>
            <li><Link to="/services/application-development">Application Development</Link></li>
            <li><Link to="/services/ui-ux-design">UI/UX Design</Link></li>
            <li><Link to="/services/digital-marketing">Digital Marketing</Link></li>
            <li><Link to="/services/data-analytics">Data & Analytics</Link></li>
            <li><Link to="/services/cloud-solutions">Cloud Solutions</Link></li>
          </ul>
        </div>

        {/* Company */}
        <div className="footer-col company">
          <h3>Company</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/company">Company</Link></li>
            <li><Link to="/staffing">Staffing</Link></li>
            <li><Link to="/technology">Technologies</Link></li>
            <li><Link to="/careers">Careers</Link></li>
            <li><Link to="/contact-us">Let's Talk</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col contact">
          <h3>Get in touch</h3>
          <ul>
            <li>
              <FaMapMarkerAlt size={22} color="#1f2889" style={{marginRight:'8px'}} />
              No 2, First Floor, Avvaiyar Street, Ekkatuthangal, Chennai-600032.
            </li>

            <li>
              <FaPhoneAlt size={18} color="#1f2889" style={{marginRight:'8px'}} />
              <a href="tel:+919787729398">+91 9787729398</a>
            </li>

            <li>
              <FaEnvelope size={18} color="#1f2889" style={{marginRight:'8px'}} />
              <a href="mailto:info@inypeople.com">info@inypeople.com</a>
            </li>
          </ul>
        </div>

      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <span>Copyright © Inypeople 2026. All Rights Reserved.</span>
      </div>
    </footer>
  );
}

export default Footer;